'use client';

import { FC } from 'react';
import { Star } from 'lucide-react';
import styles from './RatingBadge.module.scss';
export interface RatingBadgeProps {
  rating: number;
  reviewCount?: number;
  /** `sm` is the compact pill used by the minimal (landing) card. */
  size?: 'md' | 'sm';
}
const RatingBadge: FC<RatingBadgeProps> = ({
  rating,
  reviewCount = 0,
  size = 'md'
}) => {
  if (rating <= 0) return null;
  const isSmall = size === 'sm';
  return <span className={`${styles.ratingBadge} ${isSmall ? styles.ratingBadgeSm : ''}`} data-sentry-component="RatingBadge" data-sentry-source-file="RatingBadge.tsx">
            <Star size={isSmall ? 8 : 12} fill="#000" className={styles.starIcon} data-sentry-element="Star" data-sentry-source-file="RatingBadge.tsx" />
            <span className={styles.ratingValue}>
                {rating.toFixed(1)}
                {reviewCount > 0 && <span className={styles.reviewCount}> ({reviewCount})</span>}
            </span>
        </span>;
};
export default RatingBadge;